﻿import { AnyElement, MuWidget } from "mu-widget/lib/MuWidget";

export class SidebarToggle extends MuWidget {
    //@ts-ignore
    container: HTMLInputElement;

    container_click() {
        if (document.querySelector(".layout__side") != null) {
            const sidebar: HTMLElement = document.querySelector(".layout__side");
            sidebar.classList.toggle("hidden-sidebar");
        }
    }
}